import { render, staticRenderFns } from "./ThankYouUser.vue?vue&type=template&id=4215c73e&scoped=true"
import script from "./ThankYouUser.vue?vue&type=script&lang=js"
export * from "./ThankYouUser.vue?vue&type=script&lang=js"
import style0 from "./ThankYouUser.vue?vue&type=style&index=0&id=4215c73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215c73e",
  null
  
)

export default component.exports